import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage  } from 'react-intl';
import { getReportType } from '../utils/utils';
import '../App.css';

const common_reports = [
    {"/printers" : "Printers"},
    {"/users" : "Users"},
    {"/groups" : "Groups"},
    {"/printer" : "Printer"},
    {"/user" : "User"},
    {"/group" : "Group"},
];

class ReportName extends Component {
    constructor(props) {
        super(props);

        this.previous_report_url = this.props.report_url;

        this.getReportParams();
    }

    checkChanges(){
        if (this.previous_report_url === this.props.report_url){
            return;
        }

        this.previous_report_url = this.props.report_url;

        this.getReportParams();
    }

    getReportParams() {
        this.params = [];

        var url_only = this.props.report_url;
        var index = this.props.report_url.indexOf('?');
        if ( index !== -1)
        {
            url_only = this.props.report_url.substring(0, index);

            let query = this.props.report_url.substring(index + 1);
            let params = new URLSearchParams(query);

            for(var [key, value] of params.entries()) {
                this.params.push({[key] : value});
            }

           this.description = this.paramsToString();
        }

        this.common_report_type = this.getDescriptionForCommonReport(url_only);
    }

    getDescriptionForCommonReport(url_only)
    {
        for(var i = 0; i < common_reports.length; i++)
        {
            if (common_reports[i][url_only] !== undefined)
            {
                return common_reports[i][url_only];
            }
        }

        return undefined;
    }

    paramsToString()
    {
        let description = "";
        this.params.forEach((param) => {
            if (param["printer_id"] !== undefined)
            {
                description += this.addParamString(description, this.getPrinterName(param["printer_id"]));
            }
            else if (param["user_id"] !== undefined)
            {
                description += this.addParamString(description, this.getUserName(param["user_id"]));
            }
            else if (param["group_id"] !== undefined)
            {
                description += this.addParamString(description, this.getGroupName(param["group_id"]));
            }
            else if (param["supply_limit"] !== undefined)
            {
                description += this.addParamString(description, "Less " + param["supply_limit"] + "%");
            }
            else if (param["minpages"] !== undefined)
            {
                description += this.addParamString(description, "MinPages = " + param["minpages"]);
            }
            else if (param["maxpages"] !== undefined)
            {
                description += this.addParamString(description, "MaxPages = " + param["maxpages"]);
            }
            else if (param["color"] !== undefined)
            {
                description += this.addParamString(description, "ColorMode = " + (param["color"] === '2' ? "Color" : "B&W"));
            }
          });

        return description;
    }

    addParamString(description, value)
    {
        return (description.length > 0 ? " AND " : "") + value;
    }

    getPrinterName(id){
        if (this.props.printers === undefined || this.props.printers.length === 0)
        {
            return "PrinterId = " + id;
        }

        let prn_id = parseInt(id)
        let found_printers = this.props.printers.filter(printer => printer.id === prn_id);
        if (found_printers === undefined || found_printers.length === 0)
        {
            return "Printer Unknown";
        }

        return "Printer = " + found_printers[0].prnName;
    }

    getUserName(id){
        if (this.props.users === undefined || this.props.users.length === 0)
        {
            return "UserId = " + id;
        }

        let user_id = parseInt(id)
        let found_users = this.props.users.filter(user => user.id === user_id);
        if (found_users === undefined || found_users.length === 0)
        {
            return "User unknown";
        }

        return "User = " + found_users[0].name;
    }

    getGroupName(id){
        if (this.props.groups === undefined || this.props.groups.length === 0)
        {
            return "GroupId = " + id;
        }

        let group_id = parseInt(id)
        let found_groups = this.props.groups.filter(group => group.id === group_id);
        if (found_groups === undefined || found_groups.length === 0)
        {
            return "Group unknown";
        }

        return "User group = " + found_groups[0].name;
    }

    render() {
        this.checkChanges();

      return (
          <>
            <FormattedMessage id={getReportType(this.props.report_url)}/>{this.common_report_type !== undefined && ' - '}{this.common_report_type !== undefined && <FormattedMessage id={this.common_report_type}/>}
            <div  style={{color:"DarkGray"}}>
                {this.description !== undefined && this.description}
            </div>
          </>
    );
  }
}

const propTypes = {
    report_url: PropTypes.string.isRequired,
  };

ReportName.propTypes = propTypes;

const mapStateToProps = (state) => {
return {
    printers: state.printers,
    users: state.users,
    groups: state.usergroups,
    }
};


export default connect(mapStateToProps)(ReportName);